import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import {  Message, RestService } from '@stdoutsrl/design-kit';
import { LoaderService } from '../../service/loader.service';

@Component({
  selector: 'app-create-quiz',
  templateUrl: './create-quiz.component.html',
  styles: `
  .plus-add-block{
width: 40px;
padding-left: 20px;
padding-right: 20px;
opacity: 0;
transition-duration: 250ms;
  }
  .plus-add-block:hover{
    width: 100px;
    opacity: 1;
  }
  `,
  standalone: false
})
export class CreateQuizComponent implements OnInit {
  constructor(private router: Router,private message:Message, private rest: RestService, private loader: LoaderService,private transloco:TranslocoService) { }

  newTypeQuestion = -1
  showExample = false
  myQuiz: any = {
    questions:[]
  }
  id = ''
  indexForAddQuestion = -1
  currentSlideToShow = -1
  timeoutUpdate :any
  tipToShow = -1
  errors : string[]= []


  ngOnInit(): void {
    this.getQuizDetails()
  }

  showTip(tipIndex:number){
    setTimeout(() => {
      this.tipToShow = tipIndex
    }, 0);
  }

  changeCorrectAnswer(indexCorrect:number){
    this.myQuiz.questions[this.currentSlideToShow].question_options.map((element:any,index:number) => {
      if(indexCorrect == index){
        element.is_correct = true
        this.myQuiz.questions[this.currentSlideToShow].correct_value = element.option_text
      }else{
        element.is_correct = false
      }
      return element
    });
  }

  checkQuizIsComplete(t: any) {
    this.errors = []
    if (this.myQuiz.questions.length > 1) {
      this.myQuiz.questions.forEach((question: any, index: number) => {
        if (!question.title) {
          this.errors.push(t('errorsQuiz.noQuestion', { number: index + 1 }))
        }
        if (this.findDuplicateOptions(question.question_options.filter((dup: any) => dup.option_text))?.length > 0) {
          this.errors.push(t('errorsQuiz.sameAnswers', { number: index + 1 }))
        }
        if (!question.correct_value) {
          this.errors.push(t('errorsQuiz.missingCorrect', { number: index + 1 }))
        }
        if (question.question_options.filter((dup: any) => dup.option_text)?.length < 2 && (question.type == 1 || question.type == 2)) {
          this.errors.push(t('errorsQuiz.needTwoAnswers', { number: index + 1 }))
        }
        if (question?.correct_value?.length > 0) {
          let car = question.correct_value.split('').filter((ca: string) => ca == ' ')
          if (car.length == question?.correct_value?.length) {
            this.errors.push(t('errorsQuiz.noSpace', { number: index + 1 }))
          }
        }
      });
    } else {
      this.errors.push(t('errorsQuiz.noQuestions'))
    }
  }

  changeCurrentCorrectValue(newValue:string){
    this.myQuiz.questions[this.currentSlideToShow].correct_value = newValue
    
  }

  updateQuiz(){
    clearTimeout(this.timeoutUpdate)
    this.timeoutUpdate = setTimeout(() => {
      this.saveQuiz()
    }, 500);
  }

  updateSlides(event?: any) {
    if (event?.key == '-') { 
      clearTimeout(this.timeoutUpdate) 
    } else 
      {
      clearTimeout(this.timeoutUpdate)
      this.timeoutUpdate = setTimeout(() => {
        this.saveSlide(this.currentSlideToShow)
      }, 500);
    }
  }


  toFloat(number:string){
    return parseFloat(number)
  }

  reorderQuestions(){
    this.loader.on()
    let questions = this.myQuiz.questions
    questions = questions.map((res:any,index:number)=>{
      return {order_index: index + 1,id:res.id} 
    })
    this.rest.patch('/question/reorder',{questions:questions}).subscribe({
      next: (value) => {
        this.loader.off(true)
      },
      error: (value) => {
        this.loader.off(true)
        this.message.showMessage('Error reorder','error')
      },
    })
    
  }

  getQuizDetails() {
    this.loader.on()
    this.id = window.location.pathname.split('/')[2]
    this.rest.get(`/quiz/${this.id}`).subscribe({
      next: (value) => {
        this.myQuiz = value
        this.loader.off(true)
      },
      error: (value) => {
        this.loader.off(true)
      },
    })
  }

onMapClick(event:any){
      this.myQuiz.questions[this.currentSlideToShow].correct_value = event.latLng.lat() + ',' + event.latLng.lng()
  this.updateSlides()
}

  goBack(t: any) {
    this.router.navigate([t('routes.yourQuizs.path')])
  }

  hideModal() {
    let modalBlock = document.getElementById('modal-create-block')
    let modalContent = document.getElementById('modal-create-block-content')
    let modalInside = document.getElementById('modal-block-inside')
    if (modalBlock && modalContent && modalInside) {
      modalInside.style.transitionDuration = '50ms'
      modalInside.style.opacity = '0'
      modalContent.style.opacity = '1'
      modalContent.style.transitionDuration = '250ms'
      modalContent.style.height = '50px'
      modalContent.style.width = '50px'
      modalContent.style.borderRadius = '99px'
      setTimeout(() => {
        modalBlock.style.backgroundColor = 'rgb(0 0 0 /0)'
        modalContent.style.opacity = '0'
        setTimeout(() => {
          modalBlock.style.display = 'none'
          modalBlock.style.height = '100svh'
          modalBlock.style.width = '50px'
          modalBlock.style.rotate = '0deg'
          modalContent.style.opacity = '1'
        }, 250);
      }, 250);
    }
  }

  spawnModalBlock(event: any) {
    let modalBlock = document.getElementById('modal-create-block')
    let modalContent = document.getElementById('modal-create-block-content')
    let modalInside = document.getElementById('modal-block-inside')
    if (modalBlock && modalContent && modalInside) {
      modalInside.style.animationDuration = '0ms'
      modalInside.style.opacity = '0'
      modalBlock.style.backgroundColor = 'rgba(0 0 0 0)'
      modalContent.style.borderRadius = '99px'
      modalBlock.style.left = event.clientX + 'px'
      modalBlock.style.top = event.clientY + 'px'
      modalContent.style.height = '25px'
      modalContent.style.width = '25px'
      modalBlock.style.display = 'flex'
      modalBlock.style.alignItems = 'start'
      modalBlock.style.placeContent = 'center'
      setTimeout(() => {
        modalContent.style.height = '50px'
        modalContent.style.width = '50px'
        modalBlock.style.top = (event.clientY - 100) + 'px'
        setTimeout(() => {
          modalBlock.style.transitionDuration = '500ms'
          modalBlock.style.left = ((window.innerWidth / 2) - 25) + 'px'
          setTimeout(() => {
            let rotationDuration = 1000
            modalBlock.style.transitionDuration = rotationDuration + 'ms'
            modalBlock.style.height = '0px'
            modalBlock.style.top = ((window.innerHeight / 2)) + 'px'
            modalBlock.style.rotate = '360deg'
            setTimeout(() => {
              modalContent.style.borderRadius = '16px'
              modalBlock.style.transitionDuration = '0ms'
              modalBlock.style.height = '100svh'
              modalBlock.style.width = '100vw'
              modalBlock.style.alignItems = 'center'
              modalBlock.style.left = '0px'
              modalBlock.style.top = '0px'
              setTimeout(() => {
                modalBlock.style.transitionDuration = '500ms'
                modalBlock.style.backgroundColor = 'rgb(0 0 0 /0.35)'
                modalContent.style.transitionDuration = '500ms'
                modalContent.style.height = '50vh'
                modalContent.style.width = '500px'

                setTimeout(() => {
                  modalInside.style.transitionDuration = '500ms'
                  modalInside.style.opacity = '1'
                }, 300);
              }, 0);
            }, rotationDuration);
          }, 100);
        }, 100);
      }, 100);
    }
  }

  changeTypeQuestion(event: any) {
    this.newTypeQuestion = event.value
  }

  addIntermission(t: any) {
    this.hideModal()
    let slide :any= {
      media_url: '', correct_value: '', quiz_id: parseInt(this.id), order_index: this.indexForAddQuestion + 1, type: this.newTypeQuestion,
      question_settings: {
        base_points:0,
        bonus_correct:0,
        bonus_best:0
      }, title: `${t('typeQuestion' + (this.newTypeQuestion-1))} ${this.indexForAddQuestion + 1}`, question_options: (this.newTypeQuestion == 1 || this.newTypeQuestion == 2) ? [{ option_text: '' }, { option_text: '' }, { option_text: '' }, { option_text: '' }, { option_text: '' }] : []
    }
    this.loader.on()
    this.rest.post('/question', slide).subscribe({
      next: (value:any) => {
        this.loader.off()
        slide.id = value.id
        this.myQuiz.questions.splice(this.indexForAddQuestion, 0, slide)
        this.currentSlideToShow = this.indexForAddQuestion
        this.reorderQuestions()
      },
      error: (value) => {
        this.loader.off()
      },
    })
  }

  saveQuiz() {
    this.loader.on()
    this.rest.patch(`/quiz/${this.myQuiz.id}`, this.myQuiz).subscribe({
      next: (value) => {
        this.loader.off(true)
      },
      error: (value) => {
        this.loader.off(true)
      },
    })
  }

  saveSlide(index: number) {
    if (index > -1) {
      this.loader.on()
      let params = this.myQuiz.questions[this.currentSlideToShow]
      params.question_settings.base_points = parseFloat(params.question_settings.base_points ?? 0)
      params.question_settings.bonus_best = parseFloat(params.question_settings.bonus_best ?? 0)
      params.question_settings.wrong_answer_points = parseFloat(params.question_settings.wrong_answer_points ?? 0)
      params.question_settings.buzzer_duration_seconds = parseFloat(params.question_settings.buzzer_duration_seconds)
      params.question_settings.duration_seconds = parseFloat(params.question_settings.duration_seconds)
      if (Number.isNaN(params.question_settings.base_points)) {
        params.question_settings.base_points = 0
      }
      if (Number.isNaN(params.question_settings.bonus_best)) {
        params.question_settings.bonus_best = 0
      }
      if (Number.isNaN(params.question_settings.wrong_answer_points)) {
        params.question_settings.wrong_answer_points = 0
      }
      if (Number.isNaN(params.question_settings.buzzer_duration_seconds)) {
        params.question_settings.buzzer_duration_seconds = 5
      }
      if (Number.isNaN(params.question_settings.duration_seconds)) {
        params.question_settings.duration_seconds = 30
      }
      if(params.question_settings.duration_seconds < 1){
        params.question_settings.duration_seconds = 30
      }
      if(params.question_settings.buzzer_duration_seconds < 1){
        params.question_settings.buzzer_duration_seconds = 5
      }

      this.transloco.selectTranslateObject("alerts").subscribe((alerts: any) => {
        if (this.findDuplicateOptions(params.question_options.filter((dup: any) => dup.option_text))?.length > 0) {
          this.message.showMessage(`Q${index + 1}: ` + alerts.sameAnswers, 'error')
        }
        if (params?.correct_value?.length > 0) {
          let car = params.correct_value.split('').filter((ca: string) => ca == ' ')
          if (car.length == params?.correct_value?.length) {
            this.message.showMessage(`Q${index + 1}: ` + alerts.noSpace, 'error')
          }
        }
        if (!params.correct_value) {
          this.message.showMessage(`Q${index + 1}: ` + alerts.missingCorrect, 'error')
        }
        if (params.question_options.filter((dup: any) => dup.option_text)?.length < 2 && (params.type == 1 || params.type == 2)) {
          this.message.showMessage(`Q${index + 1}: ` + alerts.needTwoAnswers, 'error')
        }
      })
      this.rest.patch(`/question/${this.myQuiz.questions[index].id}`, params).subscribe({
        next: (value) => {
          // this.currentSlideToShow = -1
          this.loader.off(true)
          // this.getQuizDetails()
        },
        error: (value) => {
          this.loader.off(true)
        },
      })
    }
  }

  findDuplicateOptions(options:any) {
  const seen = new Map();
  const duplicates = [];
  for (const option of options) {
    const text = option.option_text.trim();

    if (seen.has(text)) {
      duplicates.push(option);
    } else {
      seen.set(text, option.id);
    }
  }
  return duplicates;
}

  changeSelectSettings(event:any,name:string){
    this.myQuiz.questions[this.currentSlideToShow].question_settings[name] = event.value
    this.updateSlides()
  }

  deleteSlide(){
    this.loader.on()
    this.rest.delete(`/question/${this.myQuiz.questions[this.currentSlideToShow].id}`).subscribe({
      next: (value) => {
        this.currentSlideToShow = -1
        this.loader.off(true)
        this.getQuizDetails()
      },
      error: (value) => {
        this.loader.off(true)
      },
    })
  }

  startLive(t:any){
    this.checkQuizIsComplete(t)
    if(this.errors.length == 0){
    this.loader.on()
    this.rest.post(`/quiz-session`,{quiz_id:parseInt(this.id)}).subscribe({
      next: (value:any) => {
        this.loader.off(true)
        this.router.navigate([`presentation/${value.join_code}`])
      },
      error: (value) => {
        this.loader.off(true)
        this.message.showMessage(t('errorStartLive'),'error')
      },
    })}
  }

  prevSessions(t:any){
    this.router.navigate([t('routes.prevSessions.path').replace(':id',this.id)])
  }

}
